import { useState, useCallback } from "react";

/**
 * useToast
 * Hook para gerenciar múltiplas notificações toast.
 *
 * Uso:
 *   const { toasts, showToast, removeToast } = useToast();
 *   showToast("Salvo com sucesso!", "success");
 *   showToast("Erro ao salvar", "error");
 *
 *   <ToastContainer toasts={toasts} onRemove={removeToast} />
 */
export default function useToast() {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = "info", duration = 4000) => {
    const id = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    setToasts((prev) => [...prev, { id, message, type, duration }]);
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  // Atalhos para tipos específicos
  const success = useCallback(
    (message, duration) => showToast(message, "success", duration),
    [showToast],
  );
  const error = useCallback(
    (message, duration) => showToast(message, "error", duration),
    [showToast],
  );
  const warning = useCallback(
    (message, duration) => showToast(message, "warning", duration),
    [showToast],
  );
  const info = useCallback(
    (message, duration) => showToast(message, "info", duration),
    [showToast],
  );

  return {
    toasts,
    showToast,
    removeToast,
    success,
    error,
    warning,
    info,
  };
}
